import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, Transition as _Transition, mergeProps as _mergeProps } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_DialogDescription = _resolveComponent("DialogDescription")!
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createBlock(_component_TransitionRoot, {
    appear: "",
    show: _ctx.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Dialog, {
        open: _ctx.isOpen,
        "initial-focus": _ctx.initialFocusElement,
        class: _normalizeClass(["overflow-y-auto fixed inset-0 z-overlay", [{'absolute overflow-y-hidden z-navigation': _ctx.position === 'navigation'}, _ctx.positionClass]]),
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["flex overflow-hidden h-screen", {'flex-col': _ctx.isTopOrBottomPosition}])
          }, [
            (_ctx.showBackdrop)
              ? (_openBlock(), _createBlock(_component_TransitionChild, {
                  key: 0,
                  as: "template",
                  enter: "duration-300 ease-in",
                  "enter-from": "opacity-0",
                  "enter-to": "opacity-100",
                  leave: "delay-100 duration-500 ease-out",
                  "leave-from": "opacity-100",
                  "leave-to": "opacity-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-black-30 cursor-pointer" })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_TransitionChild, _mergeProps({
              as: "template",
              enter: "delay-100 duration-300 ease-out",
              leave: "duration-200 ease-in"
            }, _ctx.drawerAnimation, {
              onAfterEnter: _ctx.onDialogOpen,
              onAfterLeave: _ctx.onDialogClosed
            }), {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.drawerPositionStyling)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["relative h-full", {'flex justify-center items-center': _ctx.centerContent}])
                  }, [
                    (_ctx.title)
                      ? (_openBlock(), _createBlock(_component_DialogTitle, {
                          key: 0,
                          class: _normalizeClass(["flex justify-between items-center bg-white border-b border-black border-opacity-10 p-30 text-24 leading-16", _ctx.titleClasses]),
                          as: "h4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                            _createElementVNode("button", null, [
                              _createVNode(_component_CIcon, {
                                name: "close",
                                onClick: _ctx.closeModal
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          _: 1
                        }, 8, ["class"]))
                      : _createCommentVNode("", true),
                    (_ctx.description)
                      ? (_openBlock(), _createBlock(_component_DialogDescription, { key: 1 }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.description), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _renderSlot(_ctx.$slots, "default", { close: _ctx.closeModal }, undefined, true),
                    (_ctx.showCloseButton)
                      ? (_openBlock(), _createBlock(_Transition, {
                          key: 2,
                          appear: "",
                          "enter-active-class": "animated fadeIn u-anim-dur-300 u-anim-delay-500"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              class: _normalizeClass(["overlay-close", { 'overlay-close--nav': _ctx.position === 'navigation' }]),
                              "aria-label": "close",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                            }, [
                              _createVNode(_component_c_icon, {
                                name: "icon-plus",
                                class: "rotate-45"
                              })
                            ], 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 2)
              ]),
              _: 3
            }, 16, ["onAfterEnter", "onAfterLeave"])
          ], 2)
        ]),
        _: 3
      }, 8, ["open", "initial-focus", "class", "onClose"])
    ]),
    _: 3
  }, 8, ["show"]))
}